/*
 * CMS-ready data layer.
 * Today it reads static JSON from the public /data folder. To switch to a real
 * REST API later, set REACT_APP_CMS_BASE (e.g. https://cms.mysite.com/api) and,
 * if needed, adjust `resourceUrl`. Components never change — they consume data
 * exactly as if calling a REST endpoint.
 */
const BASE = (process.env.REACT_APP_CMS_BASE || "/data").replace(/\/$/, "");
const EXT = process.env.REACT_APP_CMS_BASE ? "" : ".json";

export function resourceUrl(name) {
  return `${BASE}/${name}${EXT}`;
}

export async function fetchResource(name) {
  const res = await fetch(resourceUrl(name));
  if (!res.ok) throw new Error(`Failed to load ${name}`);
  return res.json();
}
